<template>
    <div>
        <DxDropDownBox
            ref="dropDownBoxRefName"
            :drop-down-options="dropDownOptions"
            :data-source="getCompanyInfo"
            :value.sync="currentValue"
            display-expr="거래처명"
            value-expr="거래처코드"
            content-template="contentTemplate"
        >
          <template #contentTemplate="{}">
            <dx-data-grid ref='refCompanyGrid'
              :data-source='getCompanyInfo'
              :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
              :selection="{ mode: 'single' }" :hover-state-enabled = "true" :allowColumnResizing = 'true'
              column-resizing-mode = 'widget' :allow-column-reordering = "true"
              :height='gridHeight'
              @selection-changed = "onSelectionChanged"
            >
              <DxSearchPanel
                :visible="true"
                placeholder="검색..."
              />
              <DxFilterRow
                :visible="true"
                apply-filter="auto"
              />
              <DxColumn
                :fixed="true"
                caption="거래처코드"
                data-field="거래처코드"
                width = '70'>
              </DxColumn>
              <DxColumn
                :allowEditing='true'
                caption="구분"
                data-field="거래처구분코드"
                :visible='true'
              >
                <DxLookup
                  :data-source="partnerLookup"
                  display-expr="코드명"
                  value-expr="코드"
                />
              </DxColumn>
              <DxColumn
                sort-order='asc'
                caption="거래처명"
                data-field="거래처명"
                width = '136'>
              </DxColumn>
              <dx-paging :enabled="false"/>
              <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
              <dx-sorting mode="multiple"/>
            </dx-data-grid>
          </template>
        </DxDropDownBox>
    </div>
</template>

<script>
import DxDataGrid, { DxScrolling,
  DxColumn, DxPaging, DxSorting, DxSearchPanel, DxFilterRow, DxLookup } from 'devextreme-vue/data-grid'

import DxDropDownBox from 'devextreme-vue/drop-down-box'
import ConstDef from '../ConstDef'
export default {
  name: 'companyGrid',
  data: function () {
    return {
      currentValue: this.value,
      dropDownOptions: { width: 300 },
      dataSource: null,
      gridHeight: 300,
      partnerLookup: null
    }
  },
  props: {
    value: {
      type: String,
      default: null
    },
    companyInfo: {
      type: Array,
      default: null
    },
    onValueChanged: {
      type: Function,
      default: () => function (data) {
        // console.log(data)
      }
    }
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxScrolling,
    DxDropDownBox,
    DxFilterRow,
    DxLookup
  },
  computed: {
    getCompanyInfo () {
      return this.companyInfo
    }
  },
  created () {
    this.partnerLookup = ConstDef.COMPANY_TYPE
  },
  mounted () {
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    onSelectionChanged (e) {
      // // console.log(e.selectedRowsData[0])
      this.currentValue = e.selectedRowsData[0].거래처코드
      this.onValueChanged(e.selectedRowsData[0].거래처코드)
      this.$emit('selected-company', e.selectedRowsData[0].거래처코드)
      this.$refs.dropDownBoxRefName.instance.close()
    }
  }
}
</script>

<style lang="scss">

</style>
